// extracted by mini-css-extract-plugin
export var businessHours = "Contact-module--business-hours--9a9f9";
export var fixed = "Contact-module--fixed--e1cc6 Contact-module--link--3caa9";
export var link = "Contact-module--link--3caa9";
export var modalClose = "Contact-module--modal-close--82510";
export var modalContent = "Contact-module--modal-content--1a60f";
export var modalHeading = "Contact-module--modal-heading--8ce8d default-module--font-bold--e6812";
export var modalText = "Contact-module--modal-text--cb397";
export var small = "Contact-module--small--e1fd6";
export var tel = "Contact-module--tel--6ac64";